import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden; /* Prevent horizontal scroll globally */
    box-sizing: border-box;
    width: 100%; /* Ensure full viewport width */
  }

  * {
    box-sizing: inherit; /* Ensure consistent box-sizing */
  }
`;

export default GlobalStyle;
